import { render } from "./AddOne.vue?vue&type=template&id=25cacdde&ts=true"
import script from "./AddOne.vue?vue&type=script&lang=ts"
export * from "./AddOne.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__